<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-user-plus"></i> Joining Kit</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->
        

             <div class="row row-replace m-t-30">
                 <div class="col-12 text-center">

                    <div class="container">
                        <div class="row">
                            <div class="col-6">
                                <a>
                                    <img src="assets/img/quick/joining_kit.png" width="100"> 
                                    <p class="text-danger">Regular</p>
                                </a>
                            </div>
                            <div class="col-6">
                               <a>
                                   <img src="assets/img/quick/joining_kit.png" width="100">
                                   <p class="text-danger">FTC</p>
                              </a>
                            </div>
                        </div>
                    </div>
                </div>
             </div>

             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

